const HasAccess = {
  run: (permissions, operation) => permissions && permissions[operation] && permissions[operation] === 'true',
}

export default HasAccess
